module.exports = "/_next/static/images/CreateYourDynamicData@3x-616a4d133b92de6e43557dc15720c885.webp";